document.addEventListener('DOMContentLoaded', () => {
  const customForms = document.querySelectorAll('.custom-product-options');

  customForms.forEach((customForm) => {
    ensureCheckedOption(customForm);
    let formData = getCustomFormData(customForm);
    changeButtonPrice(customForm);

    customForm.addEventListener('change', () => {
      formData = getCustomFormData(customForm);
      setActiveLabel(customForm);
      changeButtonPrice(customForm);
    });

    customForm.addEventListener('submit', (e) => {
      e.preventDefault();
      formData = getCustomFormData(customForm);
      addToCartCustom(formData, customForm);
    });
  });
});

// Products with a pack but no subscription (Forte, Magnesium Stick) render the
// options with nothing checked: the default option is the subscription, which
// does not exist. Without a checked radio, getCustomFormData throws, the submit
// handler is never attached and the button posts a bare /cart/add (400).
// Fall back to the one-time purchase, or to the first option.
function ensureCheckedOption(customForm) {
  const inputs = Array.from(customForm.querySelectorAll('input.custom-product-options__input'));
  if (!inputs.length || inputs.some(input => input.checked)) return;
  const fallback = inputs.find(input => input.dataset.type === 'one-time') || inputs[0];
  fallback.checked = true;
  setActiveLabel(customForm);
  fallback.dispatchEvent(new Event('change', { bubbles: true }));
}

function getCustomFormData(customForm) {
  let checkedInput = Array.from(customForm.querySelectorAll('input.custom-product-options__input')).find(input => input.checked);
  let checkedLabel = checkedInput.closest('label.custom-product-options__item');
  let variantId = checkedInput.dataset.variantId;
  let sellingPlanId = checkedInput.dataset.sellingPlan;
  let quantitySelectorInput = checkedLabel.querySelector('.custom-product-options__qty input[type="number"]');
  let quantity = 1
  if (quantitySelectorInput) {
    quantity = quantitySelectorInput.value;
  }

  let formData = {
    'items': [{
      'id': +variantId,
      'quantity': +quantity || 1,
      'selling_plan': +sellingPlanId || ''
    }],
    sections: "cart-popup,header"
  };

  return formData;
}

function setActiveLabel(customForm) {
  let allLabel = customForm.querySelectorAll('label.custom-product-options__item');
  allLabel.forEach(label => {
    label.classList.remove('active');
  });

  let checkedInput = Array.from(customForm.querySelectorAll('input.custom-product-options__input')).find(input => input.checked);
  let checkedLabel = checkedInput.closest('label.custom-product-options__item');
  checkedLabel.classList.add('active');
}

function changeButtonPrice(customForm) {
  let checkedInput = Array.from(customForm.querySelectorAll('input.custom-product-options__input')).find(input => input.checked);
  let checkedLabel = checkedInput.closest('label.custom-product-options__item');
  let checkedPrice = checkedLabel.querySelector('.custom-product-options__price');
  let buttonPrice = customForm.querySelector('.custom-product-options__submit-btn .custom-product-options__submit-btn-price');
  let stickyButtonPrice = document.querySelector('.custom-product-sticky-submit-btn .custom-product-options__submit-btn-price');

  if (!checkedPrice || !buttonPrice) return;

  buttonPrice.innerHTML = checkedPrice.innerHTML;
  const originInButton = buttonPrice.querySelector('.custom-product-options__price-origin');
  const originInSource = checkedPrice.querySelector('.custom-product-options__price-origin');
  if (originInButton && originInSource) {
    originInButton.innerHTML = originInSource.innerHTML;
  }

  if (stickyButtonPrice) {
    stickyButtonPrice.innerHTML = checkedPrice.innerHTML;
  }
}

// The submit button only gets aria-disabled while adding, which does not stop a
// second tap (or the sticky button). Two concurrent adds both saw "no gift yet"
// and added the subscription gift twice (#137295, #137366, #138989).
let addToCartInFlight = false;

// Keep a single subscription gift line with quantity 1. Returns the fresh cart.
async function capSubscriptionGift(cartData, giftVariantId) {
  const giftLines = (cartData.items || []).filter((item) => String(item.variant_id) === String(giftVariantId));
  const total = giftLines.reduce((sum, item) => sum + item.quantity, 0);
  if (total <= 1) return cartData;
  const updates = {};
  giftLines.forEach((item, index) => {
    updates[item.key] = index === 0 ? 1 : 0;
  });
  await fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates })
  });
  const refreshed = await fetch(window.Shopify.routes.root + 'cart.js');
  return refreshed.json();
}

async function addToCartCustom(formData, customForm) {
  if (addToCartInFlight) return;
  addToCartInFlight = true;
  const cartDrawer = document.querySelector('cart-drawer');
  const submitButton = customForm
    ? customForm.querySelector('.custom-product-options__submit-btn')
    : document.querySelector('.custom-product-options__submit-btn');

  if (submitButton) {
    submitButton.classList.add('btn--loading');
    submitButton.setAttribute('aria-disabled', true);
  }

  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        ...formData,
        sections: ['cart-drawer', 'header'],
        section_url: window.location.pathname
      })
    });
    const data = await response.json();

    if (response.ok) {
      // Get updated cart data
      const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
      let cartData = await cartResponse.json();

      const giftVariantId = customForm?.querySelector('[data-subscription-gift-variant]')?.dataset.subscriptionGiftVariant;
      const sellingPlan = formData?.items?.[0]?.selling_plan;
      const variantId = formData?.items?.[0]?.id;
      const parentItem = data.items?.find(
        (item) => String(item.variant_id ?? item.id) === String(variantId)
      );
      if (giftVariantId && sellingPlan) {
        const alreadyInCart = cartData.items?.some((item) => String(item.variant_id) === String(giftVariantId));
        if (!alreadyInCart) {
          await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: Number(giftVariantId),
                quantity: 1,
                parent_line_key: parentItem.key,
                properties: {
                  _subscription_gift: 'true'
                }
              }]
            })
          });
          const refreshedCart = await fetch(window.Shopify.routes.root + 'cart.js');
          cartData = await refreshedCart.json();
        }
        cartData = await capSubscriptionGift(cartData, giftVariantId);
      }

      cartData.sections = data.sections;

      // Update cart state
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: {
          cart: cartData
        }
      }));

      // Dispatch product added event
      document.dispatchEvent(new CustomEvent('product-ajax:added', {
        detail: {
          product: data
        }
      }));

      // Dispatch cart drawer refresh event
      document.dispatchEvent(new CustomEvent('cart:refresh', {
        detail: {
          cart: cartData
        }
      }));

      // Update every cart-count badge the same way <cart-count> does on a
      // normal add: set the number AND unhide it. The previous code only set
      // textContent, so when the cart started empty the badge kept its initial
      // `hidden` attribute and the count only appeared after a page navigation.
      const cartCountEls = document.querySelectorAll('.cart-count');
      const newItemCount = cartData.item_count || 0;
      cartCountEls.forEach((cartCount) => {
        if (newItemCount > 99) {
          cartCount.innerHTML = '<span class="text-sm">99+</span>';
          cartCount.classList.add('cart-count--small-medium');
        } else {
          cartCount.textContent = newItemCount;
          cartCount.classList.remove('cart-count--small-medium');
        }
        cartCount.hidden = newItemCount === 0;
      });
      document.documentElement.classList.toggle('cart-has-items', newItemCount > 0);

      setTimeout(() => {
        // Only initialise the upsell carousel when its container is actually
        // present. Passing a selector that matches nothing makes Swiper run
        // getComputedStyle on a null element and throw an uncaught TypeError
        // (the "getComputedStyle ... parameter 1 is not of type 'Element'"
        // error that showed up in the console on every add).
        const upsellEl = document.querySelector('.cart-upsell-products');
        if (upsellEl && window.Swiper) {
          try {
            new Swiper(upsellEl, {
              slidesPerView: 'auto',
              spaceBetween: 10,
            });
          } catch (swiperError) {
            console.warn('[Cart Upsell] Swiper init skipped:', swiperError);
          }
        }
      }, 1000);
      // Show cart drawer
      if (cartDrawer) {
        cartDrawer.show(submitButton);
      }
    } else {
      // Handle error
      document.dispatchEvent(new CustomEvent('product-ajax:error', {
        detail: {
          errorMessage: data.description
        }
      }));
    }
  } catch (error) {
    console.error('Error adding to cart:', error);
    document.dispatchEvent(new CustomEvent('product-ajax:error', {
      detail: {
        errorMessage: 'An error occurred while adding the product to cart.'
      }
    }));
  } finally {
    addToCartInFlight = false;
    if (submitButton) {
      submitButton.classList.remove('btn--loading');
      submitButton.removeAttribute('aria-disabled');
    }
  }
}

function increaseQuantityCustom(button) {
  button.previousElementSibling.value = ++button.previousElementSibling.value;
}

function decreaseQuantityCustom(button) {
  if (button.nextElementSibling.value <= 1) {
    button.nextElementSibling.value = 1;
  } else {
    button.nextElementSibling.value = --button.nextElementSibling.value;
  }
}